import { TableOptions } from '../../interfaces/options';
import { Column } from '../../models';

export const DefaultTableOptions: TableOptions<any> = {
	// wouldn't build without <any>
	//propertyModel: Column,
	propertyModel: <any>Column,
	visible: {
		delete: true,
		new: true,
		filter: true,
		invalid: true
	}
};
